import useMods from '@hooks/useMods';

import PropTypes from 'prop-types';
import React from 'react';

const Pricing = ({ children, mods={} }) => {
    const { className } = useMods(Pricing, { mods });

    return (
        <div
            className={ className }
        >
            { children }
        </div>
    );
};

Pricing.displayName = 'Pricing';

Pricing.propTypes = {
    children: PropTypes.node,
    mods: PropTypes.object
};

export default Pricing;
